<template>
  <div>
    <AppDatePicker v-model.trim="model.$model"
                  :class="{'invalid': isErrored || birthDateErrors.length > 0}"
                  :label="$t('common.birthDate')"
                  :clearable="false"
                  :error-messages="birthDateErrors"
                  :error="isErrored"
    />
    <AppTextFieldSuggestion v-if="displaySuggestedValue"
                            :suggestedValue="suggestedValue"
                            @validate="model.$model = suggestedValue"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppDatePicker from '@/common/AppDatePicker.vue'
import AppTextFieldSuggestion from '@/common/identity-checking/AppTextFieldSuggestion.vue'
import { formFieldErrors } from '@/common/utils/form'
import { ID_CHECK_ERRORS } from '@/common/utils/idCheckErrors'

export default {
  name: 'BirthDate',
  components: { AppDatePicker, AppTextFieldSuggestion },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['idCheckError']),
    ...mapGetters('user', ['hasIdCheckErrorInfo']),
    birthDateErrors () {
      return formFieldErrors(
        this.model,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('common.birthDate') })],
          ['minValue', this.$t('common.validations.invalid', { fieldName: this.$t('common.birthDate') })],
          ['maxValue', this.$t('common.validations.invalid', { fieldName: this.$t('common.birthDate') })],
        ],
      )
    },
    isErrored () {
      return this.hasIdCheckErrorInfo &&
        this.idCheckError.errors.includes(ID_CHECK_ERRORS.ERROR_BIRTHDATE_MISMATCH) &&
        this.displaySuggestedValue
    },
    suggestedValue () {
      return this.idCheckError?.suggestedValues?.birthDate
    },
    displaySuggestedValue () {
      return this.suggestedValue && this.suggestedValue !== this.model.$model
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.invalid input) {
  color: rgb(var(--v-theme-text-danger)) !important;
}
</style>
